export { default } from "./SubjectIcon";
